module.exports = __webpack_public_path__ + "img/11.a8fc3428.png";